import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient, private router: Router) {}

  async userLogin(data) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      };
      let response = await this.http
        .post(`${appApiResources.login}`, data, httpOptions)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  async userLogOut(){
    localStorage.clear()
    this.router.navigate(['/login'])
  }

}
